import { render, staticRenderFns } from "./SkyCurrencies.vue?vue&type=template&id=a8804f34&scoped=true"
import script from "./SkyCurrencies.vue?vue&type=script&lang=js"
export * from "./SkyCurrencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8804f34",
  null
  
)

export default component.exports